import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Card, CardTitle } from 'react-toolbox/lib/card'
import { Flex } from 'reflexbox'
import { Avatar } from 'react-toolbox/lib/avatar'
import FontIcon from 'react-toolbox/lib/font_icon'

import ApproverCard from './ApproverCard'

import theme from './UserPendingCard.scss'

const UserPendingCard = (props) => {
  let {
    name,
    roles,
    email,
    image
  } = props

  return (
    <ApproverCard
      theme={theme}
      name={name}
      roles={roles}
      email={email}
      image={image}
      status='Pending'
    />
  )
}

UserPendingCard.propTypes = {
  action: PropTypes.string,
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
}

export default CSSModules(UserPendingCard, theme)
